import { CreditIcon, DebitIcon, X } from "@app/sharedComponents/Icons/Icons";
import { ThemedView, ThemedText, ThemedPressable, themeColorSet } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import dayjs from "dayjs";
import Stepper from '../../../../assets/Icons/StepperInProgress'
import Right from '../../../../assets/Icons/Right'
import { useAppSelector } from "@app/store/hooks";
import {Image} from 'react-native';
import { WarningCircle } from '@sharedComponents/Icons/Icons';
import { Repayment } from "@voltmoney/component/lib/repayment/Repayment";

const TransactionDetails = ({onClose,transactionDetail})=>{
    const {transactionType,transactionStatus,amount,description,remark,settledOn,outStandingBalance,expectedSettlingDate,longDescription,createdOn,utrNumber,modeOfTransfer} = transactionDetail
    const isTrasactionPending = transactionStatus === "PENDING_SETTLEMENT";
    const isTransactionFailed = transactionStatus === "FAILED";
    const isTransactionSettled = transactionStatus === "SETTLED";
    const isWithDrawalRequest = transactionType === "DEBIT";
    const isWithDrawalFaiilure = isTransactionFailed && isWithDrawalRequest;
    const {accountNumber,bankCode} = useAppSelector((state) => state.auth.userProfile?.bankDetails);

    const pendingTransaction = (
        <>
                <ThemedView m="lg" mb="2xs" p='lg' borderWidth={1} borderColor="border-primary" borderRadius="lg" backgroundColor="bg-fill-primary">
                <ThemedView flexDirection='row' mb="4xl"> 
                <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={32} height={32} borderRadius="full" justifyContent="center" alignItems="center">
                        <ThemedView backgroundColor="bg-surface-primary" width={24} height={24} borderRadius="full" justifyContent="center" alignItems="center">
                        <Right size={16} color="#2D57D9"/>
                        </ThemedView>
                    </ThemedView>
                    {
                        isWithDrawalRequest ? 
                        <ThemedView ml='sm'>
                                <ThemedText variant='b3s' color='text-disabled'>Withdrawal request received</ThemedText>
                                <ThemedText variant='b4r' color='text-secondary'>Placed on {dayjs(createdOn).format('h:mm A, DD-MMM')}</ThemedText>  
                        </ThemedView>:
                        <ThemedView ml='sm'>
                            <ThemedText variant='b3s' color='text-disabled'>Payment accepted for settlement</ThemedText>
                            <ThemedText variant='b4r' color='text-secondary'>Paid via {modeOfTransfer} on {dayjs(createdOn).format('h:mm A, DD-MMM')}</ThemedText>  
                        </ThemedView>
                    }
                            
                        </ThemedView>
                <ThemedView height={1}  backgroundColor="bg-action-primary" width={50} position='relative' bottom={25}  left={-10} style={{position:'relative',rotate:"90deg"}} zIndex={-10} />

                        <ThemedView flexDirection='row' > 
                            <Stepper/>
                            {isWithDrawalRequest ?
                            <ThemedView  ml='sm'>
                                <ThemedText variant='b3s' color='text-primary'>Expected transfer by</ThemedText>
                                <ThemedText variant='b4r' color='text-primary'>{dayjs(expectedSettlingDate).format('h:mm A, DD-MMM')} </ThemedText>  
                            </ThemedView>:
                            <ThemedView  ml='sm' flex={1} flexWrap="wrap">
                                <ThemedText variant='b3s' color='text-primary'>Settlement under processing</ThemedText>
                                <ThemedText variant='b4r' color='text-primary'>It may take up to 2 working days for the payment to reflect in the statement. Don’t worry, no additional interest will be charged.</ThemedText>  
                            </ThemedView>
                            }
                        </ThemedView>
                        {remark && !isWithDrawalFaiilure &&
                    <ThemedView flexDirection='row' flexWrap='wrap' flex={1} backgroundColor='bg-fill-warning' p="md" mx='lg' borderRadius='sm' >
                        <ThemedText variant='b4r' color='text-primary'>{remark} </ThemedText>
                    </ThemedView>
                    }
                </ThemedView>
                <ThemedView p="lg">

                {isWithDrawalRequest &&
                <>
                <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg" />
                <ThemedText color="text-secondary" variant="b4r">Withdrawal status</ThemedText>
                <ThemedText color="text-primary" variant="b3m">In progress</ThemedText> 
                </>
                }
                {isTransactionSettled && 
                <>
                    <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg" />
                    <ThemedText color="text-secondary" variant="b4r">{'Transaction reference numbers'}</ThemedText>
                    <ThemedText color="text-primary" variant="b3m">{utrNumber==="" ? 'null':utrNumber}</ThemedText> 
                </>
                }
                <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg" />
                <ThemedView flexDirection="row" alignItems="center" justifyContent="space-between">
                    <ThemedView>
                        <ThemedText color="text-secondary" variant="b4r">Bank account</ThemedText>
                        <ThemedText color="text-primary" variant="b3m">{accountNumber}</ThemedText> 
                    </ThemedView>
                    <Image
                        source={{uri:`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bankCode??'default'}.png`}}
                        style={{width: 40, height: 40}}
                    />
                </ThemedView>
               <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg" />
                </ThemedView>
                </>
    )

    const transactionSettled = (
        <ThemedView p="lg">
            <ThemedText color="text-secondary" variant="b4r">Date</ThemedText>
            <ThemedText color="text-primary" variant="b3m">{dayjs(isTrasactionPending ?createdOn : settledOn).format('DD MMMM YYYY')}</ThemedText> 
            <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg" />
            <ThemedText color="text-secondary" variant="b4r">Type</ThemedText>
            <ThemedText color="text-primary" variant="b3m">{transactionType}</ThemedText> 
            <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg" />
            <ThemedText color="text-secondary" variant="b4r">Outstanding balance</ThemedText>
            <ThemedText color="text-primary" variant="b3m">₹{formatIndianCurrency(outStandingBalance)}</ThemedText> 
            <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg" />
            <ThemedText color="text-secondary" variant="b4r">Transaction description</ThemedText>
            <ThemedText color="text-primary" variant="b3m">{longDescription}</ThemedText> 
        </ThemedView>
    )

    const transactionFailed = (
        <ThemedView p="lg">
                <ThemedText color="text-secondary" variant="b4r">Date</ThemedText>
                <ThemedText color="text-primary" variant="b3m">{dayjs(isTrasactionPending ?createdOn : settledOn).format('DD MMMM YYYY')}</ThemedText> 
                <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg" />
                <ThemedText color="text-secondary" variant="b4r">{'Transaction reference numbers'}</ThemedText>
                <ThemedText color="text-primary" variant="b3m">{utrNumber==="" ? 'null':utrNumber}</ThemedText> 
                <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg" />
                <ThemedText color="text-secondary" variant="b4r">Payment mode</ThemedText>
                <ThemedText color="text-primary" variant="b3m">{modeOfTransfer===""?'null':modeOfTransfer}</ThemedText> 
                <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg" />
                <ThemedText color="text-secondary" variant="b4r">Type</ThemedText>
                <ThemedText color="text-primary" variant="b3m">{transactionType}</ThemedText> 
        </ThemedView>
    )

    const withdrawFailed = (
        <ThemedView p="lg">
                <ThemedText color="text-secondary" variant="b4r">Amount</ThemedText>
                <ThemedView flexDirection="row" alignItems="center" justifyContent="space-between">
                        <ThemedText color="text-primary" variant="b3m">₹{formatIndianCurrency(Number(amount))}</ThemedText>
                        <ThemedView flexDirection="row" alignItems="center">
                            <WarningCircle weight="fill" size={12} color={themeColorSet["icon-error"]} />
                            <ThemedText variant="b5r" color="text-error"> Failed</ThemedText>
                        </ThemedView>
                </ThemedView>
                <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg" />
                <ThemedText color="text-secondary" variant="b4r">Request failed on</ThemedText>
                <ThemedText color="text-primary" variant="b3m">{dayjs(settledOn).format('DD MMMM YYYY hh:mm A')}</ThemedText> 
                <ThemedView height={1} width={'100%'} backgroundColor="border-primary" my="lg" />
                <ThemedText color="text-secondary" variant="b4r">Withdrawal request placed on</ThemedText>
                <ThemedText color="text-primary" variant="b3m">{dayjs(createdOn).format('DD MMMM YYYY hh:mm A')}</ThemedText> 
        </ThemedView>
    )
    return (
        <ThemedView backgroundColor="bg-fill-primary">
            <ThemedView p="lg" flexDirection="row" alignItems="center" >
                {transactionType==="CREDIT" ?<CreditIcon/> :<DebitIcon />}
                <ThemedView flex={1} ml="lg">
                    <ThemedView flexDirection="row" justifyContent="space-between" >
                        <ThemedText color="text-secondary" variant="b4r" >{transactionType==="CREDIT" ? 'Repayment ':'Withdrawal ' }amount</ThemedText>
                    </ThemedView>
                    <ThemedView flexDirection="row" alignItems="baseline">
                        <ThemedText color="text-primary" variant="l5">₹</ThemedText>
                        <ThemedText color="text-primary" variant="h5b">{formatIndianCurrency(Number(amount))}</ThemedText>
                        {isTransactionFailed &&!isWithDrawalFaiilure &&
                        <ThemedView flexDirection="row" alignItems="center" ml="sm">
                            <WarningCircle weight="fill" size={12} color={themeColorSet["icon-error"]} />
                            <ThemedText variant="b5r" color="text-error"> Failed</ThemedText>
                        </ThemedView>}
                    </ThemedView>
                </ThemedView>
            </ThemedView>
            <ThemedView height={1} width={'100%'} backgroundColor="border-primary" />
            {isTransactionFailed && !isWithDrawalFaiilure && <ThemedView backgroundColor='bg-fill-warning' p='md' borderRadius='sm' mx="lg" mt="lg">
                    <ThemedText variant='b4r' color='text-primary' > 
                    <ThemedText variant='b4b' color='text-primary' >Note: </ThemedText>
                        Any amount deducted from your account will be refunded to your account in 5-7 business days</ThemedText>
                </ThemedView>}
            {isTrasactionPending && pendingTransaction}
            {isTransactionSettled && transactionSettled}
            {isTransactionFailed && !isWithDrawalFaiilure && transactionFailed}
            {isWithDrawalFaiilure && withdrawFailed}
        </ThemedView>
    )
}

export default TransactionDetails;